import { cn } from '@/lib/utils';
import styles from './marketo-form-shimmer.module.scss';

type MarketoFormShimmerProps = {
  className?: string;
};

/**
 * Shimmer component that mimics the Marketo form layout while loading
 */
export const MarketoFormShimmer = ({ className }: MarketoFormShimmerProps) => {
  return (
    <div className={cn(styles.shimmer, className)}>
      {/* Form grid container */}
      <div className={styles.formGrid}>
        {/* First Name */}
        <div className={styles.fieldContainer}>
          <div className={styles.labelShimmer} />
          <div className={styles.inputShimmer} />
        </div>

        {/* Last Name */}
        <div className={styles.fieldContainer}>
          <div className={styles.labelShimmer} />
          <div className={styles.inputShimmer} />
        </div>

        {/* Email Address */}
        <div className={styles.fieldContainer}>
          <div className={styles.labelShimmer} />
          <div className={styles.inputShimmer} />
        </div>

        {/* Phone Number */}
        <div className={styles.fieldContainer}>
          <div className={styles.labelShimmer} />
          <div className={styles.inputShimmer} />
        </div>

        {/* Company Name */}
        <div className={styles.fieldContainer}>
          <div className={styles.labelShimmer} />
          <div className={styles.inputShimmer} />
        </div>

        {/* Job Title */}
        <div className={styles.fieldContainer}>
          <div className={styles.labelShimmer} />
          <div className={styles.inputShimmer} />
        </div>

        {/* Disclaimer/Agreement - spans full width */}
        <div className={styles.disclaimerContainer}>
          <div className={styles.disclaimerText} />
        </div>

        {/* Submit Button - spans full width */}
        <div className={styles.buttonContainer}>
          <div className={styles.buttonShimmer} />
        </div>
      </div>
    </div>
  );
};
